export default __webpack_public_path__ + "static/media/google-adwords-logo.b2e933e5.png";